// extracted by mini-css-extract-plugin
export var defaultWrapper = "_i1-3";
export var downloadButton = "_i1-4";
export var fileContainer = "_i1-9 _i1-7";
export var fileContainerBase = "_i1-7";
export var fileContainerFixedHeight = "_i1-8 _i1-7";
export var fileInfo = "_i1-5";
export var fileInfoWidthRestricted = "_i1-6";
export var fileType = "_i1-1";
export var fileTypeName = "_i1-2";
export var image = "_i1-0";
export var link = "_i1-b";
export var overflowEllipsis = "_i1-a";